<section class="forms" id="forms">
  <div class="title">
    <h1>
      Forms and Concentrations
    </h1>
  </div>

  <div class="list">
    <!-- Tablets -->
    <div data-aos="fade-up" data-aos-duration="500" *ngFor="let form of forms" class="card">
      <div  class="card__image">
        <img [src]="'../../../assets/'+form.type+'.svg'" alt="">
      </div>

      <!-- <div *ngIf="form.type == 2" class="card__image">
        <img src="../../../assets/Capsule.svg" alt="">
      </div>

      <div *ngIf="form.type == 3" class="card__image">
        <img src="../../../assets/Injection.svg" alt="">
      </div> -->

      <div class="card__title">
        <h2>
          {{form.type}}
        </h2>
      </div>
<!-- 
      <div  *ngIf="form.type == 2" class="card__title">
        <h2>
          Capsules
        </h2>
      </div>

      <div  *ngIf="form.type == 3" class="card__title">
        <h2>
          Injection
        </h2>
      </div> -->

      <div class="card__concentrations">
        <div class="card__concentrations__title">
          <h4>
            Concentrations
          </h4>
        </div>
        <div class="card__concentrations__desc">
          <span *ngFor="let Concentration of form.concentration">{{Concentration}} </span>
        </div>
      </div>
    </div>

    <!-- Capsules -->
    <!-- <div class="card">


      <div class="card__concentrations">
        <div class="card__concentrations__title">
          <h4>
            Concentrations
          </h4>
        </div>
        <div class="card__concentrations__desc">
          <span *ngFor="let Concentration of Concentrations">{{Concentration}} mg </span>

        </div>
      </div>
    </div> -->

    <!-- Injection -->
    <!-- <div class="card">


      <div class="card__concentrations">
        <div class="card__concentrations__title">
          <h4>
            Concentrations
          </h4>
        </div>
        <div class="card__concentrations__desc">
          <span *ngFor="let Concentration of Concentrations">{{Concentration}} mg </span>

        </div>
      </div>
    </div> -->
  </div>
</section>
